import { render, staticRenderFns } from "./ModeloImagenes.vue?vue&type=template&id=657961ac"
import script from "./ModeloImagenes.vue?vue&type=script&lang=js"
export * from "./ModeloImagenes.vue?vue&type=script&lang=js"
import style0 from "./ModeloImagenes.vue?vue&type=style&index=0&id=657961ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports